import * as React        from "react";

import {FontAwesomeIcon}    from "../../../../../../xpresso/node_modules/@fortawesome/react-fontawesome";
import {
    faDownload,
}                           from "../../../../../../xpresso/node_modules/@fortawesome/free-solid-svg-icons";

import "./edit-mailing-list-modal.scss";

import {isApiTrue}                              from "@Common/logic/is-api-true";
import {cs}                                     from "@Common/react/chain-services";
import {consumeContext}                         from "@Common/react/context";
import {ComponentLink, makeChain, valueHelper}  from "@Common/react/cst2";
import {Static2}                                from "@Common/react/static-2";
import {UseState}                               from "@Common/react/use-state";

import {DownloadMailingList}     from "../../../../../../xpresso/src/routes/account/common/mailing-lists-panel/download-mailing-list";

import {DeprecatedModalService2} from "../../../common/design2/modal-service/modal-service";
import {MailingListDetailsTable} from "../../mailing-list-details-table/mailing-list-details-table";
import {changeNestedValue} from "../../../../../utils/arr-path";

export const EditMailingListModal = ({entityId, next: rootNext}) => cs(
    consumeContext("apis"),
    ["modal", ({}, next) => DeprecatedModalService2({
        render: ({ml, onChangeCount}, setState) => ({
            content: next({
                ml,
                onChangeCount,
                setState,
                close: () => setState(),
            }),
        }),
        xdQaName: "Edit Mailing List",
        next: rootNext,
    })],

    ["mailingListDetailsTable", ({modal}, next) => MailingListDetailsTable({
        mailingListId: modal.ml.id,
        entityId,
        onChangeCount: modal.onChangeCount,
        xdQaNamePrefix: "Edit Mailing List",
        next,
    })],
    ["downloadMailingList", ({modal}, next) => DownloadMailingList({
        next,
        mailingList: modal.ml
    })],
    ({apis, modal, mailingListDetailsTable, downloadMailingList}) => (
        <div className="edit-mailing-list-modal-42b">
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name="Edit Mailing List">
                    Edit Mailing List:
                    <NameEditor
                        onSave={async (name) => {
                            try {
                                await apis.next.mailing.updateListName({idList: modal.ml.id, name});
                                modal.setState(changeNestedValue(modal, ["ml", "mailingListName"], () => name));
                                modal.onChangeCount(); // triggers parent reload
                            } catch (e) {
                                window.alert("An error occurred while updating the mailing list name.");
                                throw e;
                            }
                        }}
                        value={modal.ml.mailingListName}
                    />
                </div>
            </div>
            
            <div className="content">
                <div className="header">
                    {!isApiTrue(modal.ml.purchaseRequired) && <a
                        className="csv-download"
                        onClick={() => {
                            downloadMailingList({mailingList: modal.ml});
                        }}
                        xd-qa-type="button"
                        xd-qa-name="Download Mailing List"
                    >
                        <span className="text" xd-qa-type="label" xd-qa-name="Download">Download</span>
                        <span>
                            <FontAwesomeIcon key={modal.ml.id + " download"} className="download-icon" icon={faDownload} xd-qa-type="icon" xd-qa-name="Download"/>
                        </span>
                    </a>}
                    {mailingListDetailsTable.searchInput}
                </div>
                <div className="box">
                    {mailingListDetailsTable.table}
                </div>
            </div>

            <div className="footer">
                <button {...{
                    className: "next",
                    onClick: modal.close,
                    "xd-qa-type": "button",
                    "xd-qa-name": "Edit Mailing List Close",
                }}>
                    Close
                </button>
            </div>
        </div>
    )
);

const NameEditor = ({onSave: emitSave, value}:{
    onSave ?: (value: string) => Promise<void>,
    value   : string,
}) => (
    makeChain<JSX.Element>()
    .then("state", ({}, next:ComponentLink<typeof UseState<{dirtyValue: string, disabled: boolean, editing: boolean}>>) => (
        UseState({next, initValue: {dirtyValue: value, disabled: false, editing: false}})
    ))
    .then("inputRefStatic", ({}, next:ComponentLink<typeof Static2<HTMLInputElement>>) => (
        Static2({next})
    ))
    .then("save", valueHelper(({state: {onChange: setState, value: {dirtyValue, editing}}}) => (
        async () => {
            if (dirtyValue.length === 0) return;

            setState({disabled: true, editing, dirtyValue});
            try {
                await emitSave?.(dirtyValue);
                setState({disabled: false, editing: false, dirtyValue: value});
            } catch (e) {
                setState({disabled: false, editing, dirtyValue});
            }
        }
    )))
    .then(({inputRefStatic, save, state: {onChange: setState, value: {dirtyValue, disabled, editing}}}) => (
        editing
            ? (
                <div className="name-editor">
                    <input
                        ref={inputRefStatic.set}
                        disabled={disabled}
                        onChange={e => setState({disabled, editing, dirtyValue: e.target.value})}
                        onKeyDown={e => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                save();
                            }
                            else if (e.key === "Escape") {
                                e.stopPropagation();
                                setState({disabled, editing: false, dirtyValue: value});
                            }
                        }}
                        value={dirtyValue}
                        xd-qa-type="textbox"
                        xd-qa-name="Edit Name"
                    />
                    <button
                        disabled={disabled}
                        onClick={save}
                        xd-qa-type="button"
                        xd-qa-name="Save"
                    ><i className="fa fa-check"/></button>
                    <button
                        disabled={disabled}
                        onClick={() => setState({disabled: false, editing: false, dirtyValue: value})}
                        xd-qa-type="button"
                        xd-qa-name="Cancel"
                    ><i className="fa fa-close"/></button>
                </div>
            )
            : (
                <div className="name-editor">
                    {value}
                    <button
                        onClick={() => {
                            setState({disabled, dirtyValue: value, editing: true}, () => {
                                const input = inputRefStatic.get();
                                input?.focus();
                                input?.select();
                            });
                        }}
                        xd-qa-type="button"
                        xd-qa-name="Edit"
                    ><i className="fa fa-pencil"/></button>
                </div>
            )
    ))
    .run()
);

